export default "__VITE_ASSET__V$gl0lUH__ 400w, __VITE_ASSET__DZDK4Lhd__ 800w, __VITE_ASSET__DmeNijLd__ 1024w";